import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';

import { RemindersPanelComponent } from './components/reminders-panel.component';
import { AddReminderModalComponent } from './components/add-reminder-modal/add-reminder-modal.component';
import { ReminderCardComponent } from './components/reminder-card/reminder-card.component';
import { ReminderAlertModalComponent } from './components/reminder-alert-modal/reminder-alert-modal.component';

// Services
import { BrowserNotificationService } from './services/browser-notification.service';
import { ReminderAlertService } from './services/reminder-alert.service';

@NgModule({
  declarations: [
    RemindersPanelComponent,
    AddReminderModalComponent,
    ReminderCardComponent,
    ReminderAlertModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMenuModule,
    MatIconModule,
    MatTooltipModule,
    MatSelectModule,
    MatCheckboxModule,
    MatChipsModule
  ],
  exports: [
    RemindersPanelComponent
  ],
  providers: [
    BrowserNotificationService,
    ReminderAlertService
  ]
})
export class RemindersModule { }
